import { createFetch } from "@vueuse/core";
import { usePage } from "@inertiajs/vue3";
import Nprogress from "nprogress";
import { useSettingsStore } from "@/store/settings";
const useFetch = createFetch({
    combination: 'chain',
    options: {
        beforeFetch(ctx) {
            let { options } = ctx
            const token = usePage().props.csrf_token
            if (token) {
                options.headers = {
                    ...options.headers,
                    "X-CSRF-TOKEN": token,
                };

                ctx.options = options; 
            }
            return ctx;
        },
        afterFetch(ctx) {
            if(Nprogress.isStarted()){
                Nprogress.done();
            }
            return ctx;
        },
        onFetchError(ctx) {
            const { response } = ctx;
            if(Nprogress.isStarted()){
                Nprogress.done();
            }
            
            let {setNotificationMessage} = useSettingsStore();
            if( !response || !response?.status) {
                return ctx;
            }
            switch (response.status) {
                case 401:
                    setNotificationMessage({
                        message: "You are not authorized to perform this action. Please login and try again",
                        type: "error"
                });
                    break;
                case 403:
                    setNotificationMessage({
                        message: "You are forbidden from performing this action",
                        type: "error"
                    });
                    break;
                case 404:
                    setNotificationMessage({
                        message: "The requested resource was not found",
                        type: "error"
                    });
                    break;
                case 419:
                    setNotificationMessage({
                        message: "Your session has expired. Please refresh the page and try again",
                        type: "error"
                    });
                    break;
                case 422:
                    break;
                case 500:
                case 503:
                    setNotificationMessage({
                        message: "An error occurred while processing your request",
                        type: "error"
                    });
                    break;
                default:
                    break;
            }

            return ctx;

        }
    }
});

export { useFetch };
